<template lang="html">

  <section class="pe_game type-crossword">
    
    <GameMenu />

    <div class="pe_container">

      <Cluelist 
        initialDirection="across"
        class="pe_left"
      />

      <div class="pe_game-wrap">
        <Grid 
          type="crossword"
          ref="crossword"
        />
        <CurrentClue v-show="isPlaying" />
      </div>

      <Cluelist 
        initialDirection="down"
        class="pe_right"
      />
      
      <div v-show="isPlaying" :class="keyboardClass"></div>

    </div>
    
    <!-- <Adsense
      data-ad-client="ca-pub-4799626540510986"
      data-ad-slot="4304747998"
      data-ad-format="auto"
      data-full-width-responsive="true" 
      data-ad-test="on" 
    /> -->
    <transition name="delay">
      <CompletedModal 
        v-show="completed && !manuallyClosedModal"
        @CloseCompletedModal="closeCompModal"
        
      />
    </transition>

  </section>

</template>

<script lang="js">

  import { mapActions, mapState, mapGetters } from 'vuex'

  import Grid from '@puzzleapps/crossword/src/components/Grid'
  import GameMenu from '@puzzleapps/shared/src/components/ui/GameMenu'
  import Cluelist from '@puzzleapps/crossword/src/components/Cluelist'
  import CurrentClue from '@puzzleapps/crossword/src/components/CurrentClue'
  import CompletedModal from '@puzzleapps/shared/src/components/ui/CompletedModal2'
  
  import Keyboard from 'simple-keyboard'
  import 'simple-keyboard/build/css/index.css'
  
  export default  {
    name: 'game',
    props: {      
      keyboardClass: {
        default: "simple-keyboard",
        type: String
      },
      input: {
        type: String
      }
    },
    components: {
      Grid,
      Cluelist,
      CompletedModal,
      CurrentClue,
      GameMenu,
    },

    data() {
      return {
        keyboard: null,
        manuallyClosedModal: false,
      }
    },

    mounted () {
      // this.createMobileKeyboard()
      this.createKeyboard()
      this.selectThemeFromLocal()
      this.setScrollerHeight = this.setScrollerHeight.bind(this)
      this.setScrollerHeight()
      this.getBestTime(window.PE_CLIENTAPP_ID)

      

      if (this.$route.params.forceChallenge) {
        this.setGameMode('challenge')
        if (process.env.NODE_ENV === 'development') {
          console.log(this.setGameMode)
          console.log('route', this.$route.params);
        }
      }

      window.addEventListener('resize', this.setScrollerHeight)
    },

    destroyed() {
      this.setIsPlaying(false)
      window.removeEventListener('resize', this.setScrollerHeight)
    },

    methods: {
      ...mapActions({
        setIsPlaying: 'game/setIsPlaying',
        selectThemeFromLocal: 'userSettings/selectThemeFromLocal',
        setInputAtPos: 'grid/setInputAtPos',
        selectNextLetter: 'grid/selectNextLetter',
        toggleIsAcross: 'grid/toggleIsAcross',
        setGameMode: 'userSettings/setGameMode',
        createKeyboard: 'keyboard/createKeyboard',
        KeyPress: 'keyboard/onKeyPress',
        getBestTime: 'game/getPuzzleBestTime',

      }),

      closeCompModal()
      {

          this.manuallyClosedModal = true;
      },

      setScrollerHeight() {
        let scrollers = document.querySelectorAll('.pe_cluelist .pe_scroller')
        let header = document.querySelector('.pe_cluelist header')
        let width = window.innerWidth

        scrollers.forEach(scroller => {
          let height = width > 1024 ? 
            Math.floor(this.$refs.crossword.$el.offsetHeight - 2) :
            (this.$refs.crossword.$el.offsetHeight / 2 - 16) - header.offsetHeight + 28
          scroller.setAttribute('style',`height:${ height }px`)
        })
      },


      // TODO: move these out of view code
      // createMobileKeyboard() {
      //   this.keyboard = new Keyboard({
      //     onChange: null,
      //     onKeyPress: this.onKeyPress,
      //     layout: {
      //       default: [
      //         "q w e r t y u i o p",
      //         "a s d f g h j k l",
      //         "{shift} z x c v b n m {backspace}",
      //       ],
      //       shift: [
      //         "Q W E R T Y U I O P",
      //         "A S D F G H J K L",
      //         "{shift} Z X C V B N M {backspace}",
      //       ],
      //     },
      //     display: {
      //       "{backspace}": "⌫",
      //       "{shift}": "🗘",
      //     }
      //   })
      // },

      // TODO: move these out of view code
      onKeyPress(key) {

        if (!this.grid.selectedCell) return

        this.KeyPress(key);
      },

      
    },

    computed: {
      ...mapState({
        puzzleId: state => state.game.puzzleId,
        completed: state => state.game.completed,
        grid: state => state.grid,
        completed: state => state.game.completed,
        isPlaying: state => state.game.isPlaying,
        bestTime: state => state.game.puzzleBestTime,
      }),
      
      ...mapGetters({
        noNeighbouringCells: 'grid/noNeighbouringCells',
      }),
      
    }
  }


</script>

<style lang="scss">
  .hg-theme-default .hg-button {
    flex: 1;
  }
</style>

<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/gameContainer';

  .simple-keyboard {
    display: none;
    border-radius: 0;
    background: whitesmoke;
    margin: 0;
    // order: 4;
    position: relative;
    top: 100%;
    width: calc(100%);

    // target mobile/touch devices at any size
    @media only screen and (hover: none) and (pointer: coarse) {
      display: block!important;
    }
    // also target any device which is under 600px
    @media (max-width: 1024px) { //was 600 previously
      display: block!important;
    }
  }

  #puzzleapp.pe_puzzleapp.pe_crossword{
    min-height: 566px;
  }
  body #puzzleapp .pe_game {


    .pe_container {

      @media (max-width: $max-container-size) {
        /*height: 70.3vw;*/
        flex-wrap: wrap;
        /*flex-direction: column;*/ /*this required if having both sets of clues to the right of the grid*/
        justify-content: flex-start;
      }

      @media (max-width: 600px) {
        display: block;
        height: auto;
        //padding-bottom: 0;
      }     

      .pe_game-wrap {
        max-width: 860px;

        @media (max-width: $max-container-size) {
         /* padding: 0 1em 0 0;*/
          /*order: 1;*/
          flex: 0 0 100%;
          width: 69%;
        }

        @media (max-width: 600px) {
          padding: 0;
          width: 100%;
        }
      }

      .pe_cluelist {
        
        @media (max-width: $max-container-size) {
          flex: -1 0 48%;
          width: 31%;
          order: 2;
          margin-bottom: 16px;

          &.pe_right {
            order: 3;
            margin-bottom: 0%;
          }
        }

        @media (min-width: $tablet-min-size) and (max-width: $tablet-max-size) {
          /*flex: -1 0 48%;
          width: 31%;
          order: 2;
          margin-bottom: 16px;*/
          display:none;

          &.pe_right {
            order: 3;
            margin-bottom: 0%;
          }
        }

        @media (max-width: $phone-max-size)
        {
          display:none;
        }
      }
    }
  }



</style>
